import { TRoleNames } from 'app/railways/domains/access/features/roles/roles';
import { filterRequiredRoles } from 'app/railways/domains/access/modules/check-roles';

import { TEntityGridColumn } from '../../core/entity-grid-columns';

type EntityGridFiltersParams = {
  columns: TEntityGridColumn[];
  userRoles: TRoleNames[];
};
export class EntityGridColumns {
  private _columns: TEntityGridColumn[] = [];

  get data() {
    return this._columns;
  }

  constructor(params: EntityGridFiltersParams) {
    this._columns = filterRequiredRoles(params.columns, params.userRoles);
  }
}
